import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage';

@Injectable()
export class LocalStorageService {
    private localStore: Storage;

    constructor(localStorage: Storage) {
        this.localStore = localStorage;
    }

    getEntity(name: string) {
        return this.localStore.get(name).then((data) => {
            return JSON.parse(data);
        });
    }

    updateEntity(name: string, data: any) {
        return this.localStore.set(name, JSON.stringify(data))
        .then(() => {
            return data;
        });
    }

    purge() {
        this.localStore.clear();
    }
}


// WEBPACK FOOTER //
// ./src/services/local-storage.ts